import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: string;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  title,
  subtitle,
  tone = 'dark'
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-2xl text-center" data-id="element-123" data-mp="3f1vix8av1xar">
      <h2 className={`font-serif text-[1.85rem] font-semibold leading-tight sm:text-4xl ${tone === 'light' ? 'text-cream' : 'text-forest'}`} data-id="element-124" data-mp="3f3gg75ok7ucb">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${tone === 'light' ? 'text-cream/80' : 'text-ink-muted'}`} data-id="element-125" data-mp="bl59skjzf44u">
          {subtitle}
        </p>}
    </div>;
}